import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ToolTrackerState } from './state';
import { ToolTrackerEffects } from './state/tool-tracker.effect';
import { toolTrackerReducer } from './state/tool-tracker.reducer';

@NgModule({
  declarations: [],
  exports: [],
  imports: [
    CommonModule,
    FormsModule,
    StoreModule.forFeature(
      'tool-tracker',
      toolTrackerReducer,
      {
        initialState: ToolTrackerState.initialState,
      }
    ),
    EffectsModule.forFeature([ToolTrackerEffects]),
  ],
  providers: [
    ToolTrackerEffects,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class ToolTrackerModule {}
